<template>
  <div class="vesselschedule__box">
    <p class="font-weight-bold header1">Find Schedule</p>
    <span style="font-size: 12px; color: #1A1A1A;">Find ships schedule for your shipment</span>
    <form class="forminput" @submit.prevent="actionSearchSchedule">
      <div class="forminput--maincontainer">
        <div style="width: 20%">
          <label class="forminput--label" for="fromShipment">From</label><br />
          <div class="forminput--multiselectwrapper">
            <img class="imageiconlocation" src="@/assets/image/icon/location-marker.svg" alt="icon-destination-location" />
            <div class="vesselschedule__multipleselect" @click="closeDropdownInput">
              <multiselect
                v-model="value.portOrigin"
                name="port origin"
                :options="optionsOrigin"
                :state="errors.first('port origin') && false"
                v-validate="'required'"
                :option-height="104"
                placeholder="Port of Origin"
                track-by="locode"
                :searchable="true"
                label="name"
                :allowEmpty="false"
                :show-labels="false"
                :preserveSearch="true"
                @search-change="debounceOriginPorts"
              >
                <template slot="singleLabel" slot-scope="props">
                  <span class="option__desc">
                    <span class="option__titlebold">{{ props.option.name }}, {{ props.option.country_code }}</span>
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <div class="option__desc align-items-center p-2 m-0">
                    <img
                      :src="`https://www.searates.com/design/images/flags/4x3/${props.option.country_code.toLowerCase()}.svg`"
                      :alt="`${props.option.country_code}-flag`"
                      class="option__image"
                    />
                    <span class="option__title">{{ props.option.name }}, {{ props.option.country_code }}</span>
                  </div>
                </template>
                <span v-if="!loading.optionsOrigin" slot="noResult">NO RESULT</span>
                <span v-if="loading.optionsOrigin" slot="noResult">Loading...</span>
                <span slot="noOptions">Loading...</span>
              </multiselect>
              <p v-if="errors.has('port origin')" class="global__texterror text-left">
                {{ errors.first('port origin') }}
              </p>
            </div>
          </div>
        </div>

        <div>
          <img :class="rotating ? 'rotating' : ''" src="@/assets/image/icon/icon-arrow-rigt-left.svg" alt="icon-arrow-right-left" style="cursor: pointer; margin: 40px 10px 0px" @click="swapOriginAndDestination"/>
        </div>

        <div class="mr-2" style="width: 20%">
          <label class="forminput--label" for="toShipment">To</label><br />
          <div class="forminput--multiselectwrapper">
            <img class="imageiconlocation" src="@/assets/image/icon/location-marker.svg" alt="icon-destination-location" />
            <div class="vesselschedule__multipleselect" @click="closeDropdownInput">
              <multiselect
                v-model="value.portDestination"
                name="port destination"
                :state="errors.first('port destination') && false"
                v-validate="'required'"
                :options="optionsDestination"
                :option-height="104"
                placeholder="Port of Destination"
                track-by="locode"
                :searchable="true"
                label="name"
                :allowEmpty="false"
                :show-labels="false"
                :preserveSearch="true"
                @search-change="debounceDestinationPorts"
              >
                <template slot="singleLabel" slot-scope="props">
                  <span class="option__desc">
                    <span class="option__titlebold">{{ props.option.name }}, {{ props.option.country_code }}</span>
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <div class="option__desc align-items-center p-2 m-0">
                    <img
                      :src="`https://www.searates.com/design/images/flags/4x3/${props.option.country_code.toLowerCase()}.svg`"
                      :alt="`${props.option.country_code}-flag`"
                      class="option__image"
                    />
                    <span class="option__title">{{ props.option.name }}, {{ props.option.country_code }}</span>
                  </div>
                </template>
                <span v-if="!loading.optionsDestination" slot="noResult">NO RESULT</span>
                <span v-if="loading.optionsDestination" slot="noResult">Loading...</span>
                <span slot="noOptions">Loading...</span>
              </multiselect>
              <p v-if="errors.has('port destination')" class="global__texterror text-left">
                {{ errors.first('port destination') }}
              </p>
            </div>
          </div>
        </div>

        <div class="mr-2 position-relative" style="width: 20%">
          <label class="forminput--label" for="periodShipment">Shipping Line</label><br />
          <div class="imageShipment">
            <img src="@/assets/image/icon/icon-ship.svg" alt="icon-ship" />
          </div>
          <b-form-input v-model="value.shippingLinesText" readonly class="mt-2 input-shipment iconinput" :class="showDropdownShippingLine ? 'input-shipment--active' : ''" :title="value.shippingLinesText" @click.prevent="openDropdownShippingLine"></b-form-input>

          <div v-if="showDropdownShippingLine" class="justify-content-end position-absolute" style="z-index: 50; width: 100%">
            <div class="dropDown__2">
              <div class="d-flex align-items-center m-2">
                <input v-model="value.selectAllShippingLine" class="mr-2" type="checkbox" name="allshippingline" @click="clickAllShippingLines">
                <label for="all" class="forminput--checkboxlabel">All shipping lines</label><br>
              </div>
              <div v-for="(item, idx) in optionsShippingLines" :key="idx" class="d-flex align-items-center m-2">
                <input v-model="value.shippingLines" class="mr-2" type="checkbox" name="shippingline" :value="item.scac">
                <label :for="item.scac" class="forminput--checkboxlabel">{{item.scac}}</label><br>
              </div>
            </div>
          </div>
        </div>

        <div class="mr-2" style="width: 15%">
          <div @mouseenter="closeDropdownInput">
            <label class="forminput--label" for="dateShipment">Date</label><br />
            <b-form-datepicker
              v-model="value.dateShipment" 
              placeholder="Day, Month, Year"
              :min="getDate(new Date())" 
              :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }"
              name="Issued Date" 
              v-validate="'required'"
            ></b-form-datepicker>
          </div>
        </div>

        <div class="mr-2 position-relative" style="width: 15%">
          <label class="forminput--label" for="periodShipment">Period</label><br />
          <div class="imageShipment">
            <img src="@/assets/image/icon/icon-filter.svg" alt="icon-filter" />
          </div>
          <b-form-input v-model="value.periodText" readonly class="mt-2 input-shipment iconinput" :class="showPeriodFilter ? 'input-shipment--active' : ''" :title="value.periodText" @click.prevent="openDropdownPeriod"></b-form-input>

          <div v-if="showPeriodFilter" class="justify-content-end position-absolute" style="z-index: 50; right: 0">
            <div class="dropDown">
              <div>
                <label class="forminput--label2" for="typeShipment">Week Ahead</label><br />
                <div class="forminput--multiselectwrapper">
                  <div class="vesselschedule__multipleselect">
                    <multiselect 
                      v-model="formPeriod.weekAhead" 
                      :options="optionsWeekAhead" 
                      :option-height="104" 
                      placeholder="Select type" 
                      track-by="code" 
                      label="code" 
                      :show-labels="false" 
                      :searchable="false"
                    >
                      <template slot="singleLabel" slot-scope="props">
                        <span class="option__desc3">
                          <span class="option__title">{{ props.option.name }}</span>
                        </span>
                      </template>
                      <template slot="option" slot-scope="props">
                        <div class="option__desc2">
                          <span class="option__title">{{ props.option.name }}</span>
                        </div>
                      </template>
                      <span slot="noResult">NO RESULT</span>
                    </multiselect>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <label class="forminput--label2" for="searchOn">Search On</label><br />
                <div class="d-flex shipmentSchedule__radiowrapper">
                  <div class="d-flex radiobutton">
                    <input v-model="formPeriod.searchOn" class="mr-2" type="radio" name="searchon" value="departure">
                    <label for="departure" class="forminput--radiolabel">Departure</label>
                  </div>
                  <div class="d-flex radiobutton ml-3">
                    <input v-model="formPeriod.searchOn" class="mr-2" type="radio" name="searchon" value="arrival">
                    <label for="arrival" class="forminput--radiolabel">Arrival</label>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center mt-4">
                <div class="btn btn-select col-12" @click.prevent="actionSelectPeriod">Select</div>
              </div>
            </div>
          </div>
        </div>
        <button v-if="isLoadingDataVesselSchedule || isLoadingAvailableLines" class="btnsearch">
          <b-spinner small variant="secondary"></b-spinner>
        </button>
        <button
          v-else
          type="submit"
          class="btnsearch"
          :disabled="isLoadingAvailableLines || quotaSchedule === 0 || !value.shippingLines.length"
        >
          <img src="@/assets/image/icon/icon-search-white.svg" alt="btn-search" />
        </button>
      </div>
    </form>
  <!-- =========== end of: Form Input Shipment Schedule =========== -->
  </div>
</template>

<script>
import moment from 'moment'
import Sidebar from '@/components/global/Sidebar.vue'
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
// eslint-disable-next-line import/no-cycle
import mixin from '@/mixin'

export default {
  name: 'FormVesselSchedule',
  components: {
    Sidebar
  },
  props: {
    quotaSchedule: Number
  },
  mixins: [mixin],
  data () {
    return {
      value: {
        portOrigin: null,
        portDestination: null,
        dateShipment: new Date(),
        periodText: '1 week',
        weekAhead: { id: 1, name: '1 week', code: 1 },
        searchOn: 'departure',
        shippingLines: [],
        shippingLinesText: 'No one selected',
        selectAllShippingLine: false,
        alternativeOption: false
      },
      formPeriod: {
        periodText: '1 week',
        weekAhead: { id: 1, name: '1 week', code: 1 },
        searchOn: 'departure',
        shippingLines: [],
        shippingLinesText: 'No one selected',
        selectAllShippingLine: false,
        alternativeOption: false
      },
      optionsWeekAhead: [
        { id: 1, name: '1 week', code: 1 },
        { id: 2, name: '2 weeks', code: 2 },
        { id: 3, name: '3 weeks', code: 3 },
        { id: 4, name: '4 weeks', code: 4 },
        { id: 5, name: '5 weeks', code: 5 },
        { id: 6, name: '6 weeks', code: 6 }
      ],
      optionsShippingLines: [],
      rotating: false,
      showPeriodFilter: false,
      showDropdownShippingLine: false,
      optionsOrigin: [],
      optionsDestination: [],
      loading: {
        optionsOrigin: false,
        optionsDestination: false
      }
    }
  },
  computed: {
    ...mapGetters({
      portList: 'vesselSchedule/portList',
      isLoadingPortList: 'vesselSchedule/isLoadingPortList',
      errorPortList: 'vesselSchedule/errorPortList',

      availableLines: 'vesselSchedule/availableLines',
      isLoadingAvailableLines: 'vesselSchedule/isLoadingAvailableLines',
      errorAvailableLines: 'vesselSchedule/errorAvailableLines',

      dataVesselSchedule: 'vesselSchedule/dataVesselSchedule',
      isLoadingDataVesselSchedule: 'vesselSchedule/isLoadingDataVesselSchedule',
      errorDataVesselSchedule: 'vesselSchedule/errorDataVesselSchedule',

      company: 'settingCompany/company'
    })
  },
  mounted () {
    this.init()
  },
  created () {
    // Created for Multiselect Search Debounce
    this.debounceOriginPorts = debounce((query) => {
      if (query.length > 3) {
        this.searchPortList(query, 'origin')
      }
    }, 100)
    this.debounceDestinationPorts = debounce((query) => {
      if (query.length > 3) {
        this.searchPortList(query, 'destination')
      }
    }, 100)
  },
  methods: {
    swapOriginAndDestination () {
      this.rotating = true
      // eslint-disable-next-line no-return-assign;
      setTimeout(() => (this.rotating = false), 500);
      [this.value.portOrigin, this.value.portDestination] = [this.value.portDestination, this.value.portOrigin]
    },
    getDate (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    getDate2 (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    openDropdownPeriod () {
      this.showPeriodFilter = !this.showPeriodFilter
    },
    openDropdownShippingLine () {
      this.showDropdownShippingLine = !this.showDropdownShippingLine
    },
    closeDropdownInput () {
      if (this.showPeriodFilter) this.showPeriodFilter = false
      if (this.showDropdownShippingLine) this.showDropdownShippingLine = false
    },
    init () {
      // Init Fetch for Multiselect Options
      this.fetchAvailableLines()
      this.loading.optionsOrigin = true
      this.loading.optionsDestination = true
      const payload = 'tanjung'
      // eslint-disable-next-line no-unused-vars
      this.$store.dispatch('vesselSchedule/FETCH_PORTLIST', payload).then((res) => {
        this.optionsOrigin = this.portList
        this.optionsDestination = this.portList

        this.loading.optionsOrigin = false
        this.loading.optionsDestination = false
      })
    },
    fetchCompanyProfile () {
      this.$store.dispatch('settingCompany/FETCH_COMPANY')
    },
    fetchAvailableLines () {
      // eslint-disable-next-line no-unused-vars
      this.$store.dispatch('vesselSchedule/FETCH_AVAILABLE_LINES').then((res) => {
        this.optionsShippingLines = this.availableLines
        // this.value.shippingLines = this.optionsShippingLines.map((el) => el.scac)
        // this.selectAllShippingLine()
      })
    },
    searchPortList (query, params) {
      const payload = query
      if (params === 'origin') {
        // Origin Options Case
        this.loading.optionsOrigin = true
        // eslint-disable-next-line no-unused-vars
        this.$store.dispatch('vesselSchedule/FETCH_PORTLIST', payload).then((res) => {
          this.optionsOrigin = this.portList
          this.loading.optionsOrigin = false
        })
      } else {
        // Destination Options Case
        this.loading.optionsDestination = true
        // eslint-disable-next-line no-unused-vars
        this.$store.dispatch('vesselSchedule/FETCH_PORTLIST', payload).then((res) => {
          this.optionsDestination = this.portList
          this.loading.optionsDestination = false
        })
      }
    },
    debounceOriginPorts (query) {
      // Debounce for Search Origin
      this.loading.optionsOrigin = true
      debounce(() => {
        this.searchPortList(query, 'origin')
      }, 700)
    },
    debounceDestinationPorts (query) {
      // Debounce for Search Destination
      this.loading.optionsDestination = true
      debounce(() => {
        this.searchPortList(query, 'destination')
      }, 700)
    },
    selectAllShippingLine () {
      this.value.shippingLines = []
      this.optionsShippingLines.forEach((el) => {
        this.value.shippingLines.push(el.scac)
      })
    },
    clickAllShippingLines () {
      if (!this.value.selectAllShippingLine) {
        this.value.selectAllShippingLine = true
        this.selectAllShippingLine()
      } else {
        this.value.selectAllShippingLine = false
        this.value.shippingLines = []
        this.value.shippingLines = this.value.shippingLines
      }
    },
    actionSelectPeriod () {
      this.value.weekAhead = this.formPeriod.weekAhead
      this.value.searchOn = this.formPeriod.searchOn
      this.value.alternativeOption = this.formPeriod.alternativeOption
      this.value.periodText = `${this.value.weekAhead.name}`

      this.showPeriodFilter = false
    },
    actionSearchSchedule () {
      const payload = {
        portcode: this.value.portOrigin.locode,
        portdestinationcode: this.value.portDestination.locode,
        sealine: this.value.shippingLines,
        fromdate: this.getDate2(this.value.dateShipment),
        weeksahead: this.value.weekAhead.code,
        direction: this.value.searchOn[0].toLocaleUpperCase() // D = departure & A = arrival
      }
      if (this.company.ship_schedule_quota < payload.sealine.length && this.company.ship_schedule_quota !== 0) {
        this.openModalAlertQuota()
      } else {
        this.$validator.validateAll().then((result) => {
          if (result) {
            // eslint-disable-next-line no-unused-vars
            this.$store.dispatch('vesselSchedule/FETCH_VESSELSCHEDULE', payload).then((res) => {
              if (!this.errorDataVesselSchedule) {
                this.fetchCompanyProfile()
              }
            })
          }
        })
      }
    },
    openModalAlertQuota () {
      this.$eventHub.$emit('dialog-alert-remaining-quota')
    }
  },
  watch: {
    'value.shippingLines': function (newVal) {
      if (newVal.length === this.optionsShippingLines.length) {
        this.value.selectAllShippingLine = true
        this.value.shippingLinesText = 'All shipping lines'
      } else if (!newVal.length) {
        this.value.shippingLinesText = 'No one selected'
      } else {
        this.value.selectAllShippingLine = false
        this.value.shippingLinesText = newVal.join(', ')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vesselSchedule/FormVesselSchedule.vue